<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form :label-width="110">
        <FormItem label="选择代理商">
          <SelectAgent
            @selectAgentSuccess="selectAgentSuccess"
            @selectAgentClear="selectAgentClear" />
          <Button
            style="margin-left: 24px;"
            :disabled="!categoryId"
            type="primary"
            icon="md-add"
            @click="createItem"
          >新增代理商商品</Button>
        </FormItem>
      </Form>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row, index}" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-create"
            @click="updateItem(row, index)"
          >编辑</Button>
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-trash"
            @click="deleteItem(row)"
          >删除</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <AgentCommodityCreateUpdate ref="agentCommodityCreateUpdate" @success="createUpdateSuccess" />
  </div>
</template>

<script>
import _ from 'underscore'
import api from '../../api'
import AgentCommodityCreateUpdate from '../../components/agent/AgentCommodityCreateUpdate'
import SelectAgent from '../../components/agent/selectAgent'

export default {
  components: {
    AgentCommodityCreateUpdate,
    SelectAgent
  },
  data () {
    return {
      categories: [],
      categoryId: '',
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      queryCommodity: null,
      isOpen: false
    }
  },
  computed: {
    queryColumn () {
      return [
        {
          title: '商品编号',
          key: 'id',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品名称',
          key: 'commodityName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '销售价(元)',
          key: 'salePrice',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '销售折扣',
          key: 'discount',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '税点',
          key: 'taxPoint',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 150,
          slot: 'action',
          align: 'center'
        }
      ]
    },
    currentCategoryInfo () {
      return _.find(this.categories, item => {
        return item.id === this.categoryId
      })
    }
  },
  methods: {
    getCategory () {
      let params = {}
      if (!this.isOpen) {
        params.agentName = this.queryCommodity
      }
      api.agent.agentList({
        ...params,
        // agentName: this.queryCommodity,
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        this.categories = res.data.records || []
      }).catch(err => {
        this.$Message.error(err.message || '获取供应商列表失败，请刷新重试！')
      })
    },
    getData () {
      this.loading = true
      api.agent.agentCommodityList({
        agentId: this.categoryId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取供应商列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 新增
    createItem () {
      this.$refs.agentCommodityCreateUpdate.show('create', this.currentCategoryInfo || {})
    },
    // 编辑
    updateItem (row, index) {
      this.$refs.agentCommodityCreateUpdate.show('update', row, index)
    },
    // 删除
    deleteItem (row) {
      this.$Modal.confirm({
        title: '删除确认',
        content: `<p>您确定删除此代理的商品吗？</p>
                  <p><small class="text-danger">注：删除后，代理商对此产品的所有代理请求将会被拒绝。</small></p>`,
        loading: true,
        onOk: () => {
          api.agent.agentCommodityDelete({
            agentCommodityId: row.id
          })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.$Message.success(`删除成功!`)
            })
            .catch((err) => {
              this.$Modal.remove()
              this.$Modal.error({
                title: '抱歉',
                content: `删除失败: ` + err.message
              })
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
    },
    // 组件选中
    selectAgentSuccess (val) {
      this.categoryId = val.value
      this.pageNum = 1
      this.getData()
    },
    // 组件清空
    selectAgentClear () {
      this.categoryId = null
      this.queryData = []
    }
  },
  created () {
    this.getCategory()
  }
}
</script>
